import { Language } from '../../../pure-js/types/Antiloop'
import { StorageKey, StorageType, getElligebleStorage } from '../hooks/useLocalStorageItemHelper'

export const SUPPORTED_LANGUAGES: readonly Language[] = ['sv', 'en', 'no']

export const isSupportedLanguage = (value: unknown): value is Language =>
  typeof value === 'string' && (SUPPORTED_LANGUAGES as readonly string[]).includes(value)

/**
 * Persist language for user-web text helpers.
 *
 * IMPORTANT:
 * `getLanguageCode()` resolves from `localStorage[StorageKey.STATE].user.language`.
 * We write there directly so the next text lookup sees the updated language immediately.
 */
export const persistLanguageToLocalStateStorage = (language: Language) => {
  try {
    const storage = getElligebleStorage(StorageType.LOCAL_STORAGE)
    const json = storage.getItem(StorageKey.STATE)
    const nextStateFromStorage = json ? JSON.parse(json) : {}

    storage.setItem(
      StorageKey.STATE,
      JSON.stringify({
        ...nextStateFromStorage,
        user: {
          ...(nextStateFromStorage?.user || {}),
          language
        },
        // Keep user-web flows relying on selectedLanguage consistent too.
        selectedLanguage: language
      })
    )
  } catch (err) {
    console.warn('[persistLanguageToLocalStateStorage] Failed to persist language', err)
  }
}
